import React, { useEffect, useState } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../Firebase/config";
import { Image } from "../common/helperFunctions";

export default function Achievement() {
  useEffect(() => {
    fetchAchievements();
  }, []);

  const [achievements, setAchievements] = useState([]);
  const [loader, setLoader] = useState(true);

  async function fetchAchievements() {
    setLoader(true);
    const docRef = collection(db, "winners");
    const docSnap = await getDocs(docRef);
    let achievements = [];
    docSnap.forEach((doc) => {
      achievements.push(doc.data());
    });
    achievements.sort((a, b) => new Date(b.date) - new Date(a.date));
    setAchievements(achievements);
    console.log(achievements)
    setLoader(false);
  }

  const Loader = () => {
    return (
      <div className="flex w-full justify-center h-screen items-center">
        <div
          style={{ borderTopColor: "#2b6ceb" }}
          className="ease-linear animate-spin rounded-full border-8 border-t-8 border-gray-200 h-16 w-16"
        ></div>
      </div>
    );
  };

  return (
    <div className="pb-8 bg-white">
      {!loader ? (
        <React.Fragment>
          <h1 className="text-center text-2xl bg-white text-gray-900 pt-10 font-bold">
            Our Achievements
          </h1>
          <div className="flex w-full mb-8">
            <div className="flex mx-auto">
              <div className="w-6 h-4 mr-1 rounded-full bg-blue-600"></div>
              <div className="w-6 h-4 rounded-full bg-green-700"></div>
            </div>
          </div>
          <div className="bg-white mx-auto w-full max-w-7xl h-full px-4">
            {/* Grid Container for 3 Columns */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {achievements.map((item, i) => (
                <div
                  key={i}
                  className="bg-white border rounded-lg shadow-xl transition duration-300"
                >
                  {item.poster ? (
                    <div className="w-full h-full">
                      <Image
                        src={item.poster}
                        className="object-cover h-full rounded-lg border shadow-md w-full"
                      />
                    </div>
                  ) : (
                    <div className="p-6">
                      <h3 className="mb-2 font-bold text-blue-700 text-xl">
                      {item.Title || item.event}
                      </h3>
                      <h3 className="mb-3 text-gray-500 text-xs">
                        {item.Date || item.date}
                      </h3>
                      <p className="text-sm leading-snug tracking-wide text-gray-900 text-opacity-100">
                        {item.Description || item.desc}
                      </p>
                    </div>
                  )}

                </div>
              ))}
            </div>
          </div>
        </React.Fragment>
      ) : (
        <Loader />
      )}
    </div>
  );
}